import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useDictionary, usePage } from '@/src/app/hooks';
import { Container, AssessmentBoxes } from '@/src/ui';
import './AssessmentsPage.css';

const AssessmentsPage: React.FC = () => {
    const { translate } = useDictionary();
    const { setSubheaderTitle, setSubheaderType, setPageGrade, pageGrade } = usePage();
    document.title = translate('Assessments', 'Assessments');

    const params = useParams();
    const grade = params.grade || pageGrade;

    useEffect(() => {
        setSubheaderTitle(translate('Assessments'));
        setSubheaderType('default');

        if (grade !== pageGrade) {
            setPageGrade(grade);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translate, grade, pageGrade]);
    return (
        <Container>
            <main className="col-sm assessment-content">
                <AssessmentBoxes grade={grade} showTitle={true} />
            </main>
        </Container>
    );
};

export default AssessmentsPage;
